import PropTypes from "prop-types";
import classnames from "classnames";

import "./popover.scss";

const Popover = ({
  children,
  className,
  open,
  anchorElement,
  onClose,
  leftOffset,
  topOffset,
  anchorVertical,
  anchorHorizontal,
}) => {
  let contextTop = 0,
    contextLeft = 0;

  if (anchorElement !== null) {
    if (anchorVertical === "top") {
      contextTop = anchorElement.offsetTop + topOffset;
    } else {
      contextTop =
        anchorElement.offsetTop + anchorElement.offsetHeight + topOffset;
    }

    if (anchorHorizontal === "left") {
      contextLeft = anchorElement.offsetLeft + leftOffset;
    } else {
      contextLeft =
        anchorElement.offsetLeft + anchorElement.offsetWidth + leftOffset;
    }
  }

  const contextStyle =
    anchorElement !== null ? { top: contextTop, left: contextLeft } : {};

  return (
    <div
      className={classnames("popover", className, {
        open,
      })}
    >
      <div aria-hidden="true" className="backdrop" onClick={onClose} />
      <div className={"context"} style={contextStyle}>
        {children}
      </div>
    </div>
  );
};

Popover.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  anchorElement: PropTypes.object,
  onClose: PropTypes.func,
  leftOffset: PropTypes.number,
  topOffset: PropTypes.number,
  anchorVertical: PropTypes.oneOf(["top", "bottom"]),
  anchorHorizontal: PropTypes.oneOf(["left", "right"]),
};

Popover.defaultProps = {
  className: "",
  open: false,
  anchorElement: null,
  onClose: () => {},
  leftOffset: 24,
  topOffset: 0,
  anchorVertical: "top",
  anchorHorizontal: "right",
};

export default Popover;
